import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

import { getFeaturesFromRoute, isPageHasFeatures } from '@/utils/features-helper'
import PAGE_FEATURES from '@/constants/page-features'

async function checkPageFeaturesGuard(to: Route, from: Route, next: NavigationGuardNext) {
  if (!store.getters['auth/isAuthenticated']) {
    return next()
  }
  let isPageHasFeature = null
  const features = getFeaturesFromRoute(to)
  if ((features[0] ?? []).includes(PAGE_FEATURES.REFERRAL)) {
    if (store.getters['auth/isReferral']) return next()
    return next({ name: 'unauthorized' })
  }
  if (store.getters['auth/isFacebook']) {
    isPageHasFeature = store.getters['pages/isPageHasFeature']
  } else if (store.getters['auth/isInstagram']) {
    isPageHasFeature = store.getters['instagram/isAccountHasFeature']
  }

  if (!isPageHasFeatures(features, isPageHasFeature)) {
    return next({ name: 'unauthorized' })
  }

  return next()
}

export default checkPageFeaturesGuard
